import httpService from "../httpService";

export default {
  findByHcCaseMaster(hcCaseMasterId) {
    let params = {hcCaseMasterId: hcCaseMasterId};
    return httpService.get(`/hcCaseHotelPrice/findByHcCaseMaster`, {params});
  }
};



// WEBPACK FOOTER //
// ./src/services/khachsan/hcCaseHotelPriceService.js